var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasFooter)?_c('div',{staticClass:"container-fluid border-top pt-2 mt-5"},[_c('div',{staticClass:"text-muted text-center"},[_vm._v(_vm._s(_vm.custodianSettingsStore.investmentRiskDisclaimer))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }